import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent {
  @Input() sliceItems:number;
  @Input() scheduleOption:boolean=true;

  public faqList: Array<any> = [
    {
      question: $localize`¿Cuánto cuesta el protocolo?`,
      answer: $localize`Depende mucho de lo que se identifique que se necesite trabajar y la profundidad de los temas. La inversión por ciclo, 
      dependiendo de la formulación, va desde $2,500 hasta $3,500. 
      Los ciclos duran entre 30 y 45 días, incluyendo los días de descanso.`,
    },
    {
      question: $localize`¿Cómo puedo aprovechar al máximo mi tratamiento?`,
      answer: $localize`Es importante leer detenidamente la página de protocolo antes de comenzar su
      programa, ya que ofrece información que puede responder a muchas de sus preguntas.
      Recomendamos registros con uno de nuestros terapeutas facilitadores. Si no está
      trabajando con un terapeuta que lo apoye y esté familiarizado con este proceso e
      integración, comuníquese con su facilitador que puede ayudarlo a lograr un nivel más
      profundo de curación.`
    },
    {
      question: $localize`¿Hay alguna persona que NO deba tomar este tratamiento?`,
      answer: $localize`No se recomienda para personas que han sido diagnosticadas con esquizofrenia, o
      bipolar 2 y/o con litio o brotes psicóticos.`
    },
    {
      question: $localize`¿Cuánto tiempo debo tomar el tratamiento?`,
      answer: $localize`Idealmente el tratamiento dura 90 días para que haya un cambio en la estructura neurológica de manera permanente. Sin embargo, puedes probar un mes e ir evaluando cómo te sientes.`
    },
    {
      question: $localize`¿Qué hago una vez que completé los 90 días?`,
      answer: $localize`Lo mejor es descansar de 2 a 3 semanas y puedes retomar cuando lo desees o necesites.<br />A partir de entonces puedes tomarlo intermitentemente según tus necesidades.`
    },
    {
      question: $localize`¿La microdosis puede causar dependencia?`,
      answer: $localize`Estos suplementos no causarán dependencia. Puede detenerse en cualquier momento sin consecuencias.`
    },
    {
      question: $localize`¿Experimentaré un estado alterado de conciencia?`,
      answer: $localize`La dosis es tan pequeña que no hay efectos psicodélicos clásicos. Es normal sentir los sentidos y las emociones intensificados junto con un mayor enfoque, conciencia y energía`
    },
    {
      question: $localize`¿Qué puedo esperar sentir durante el tratamiento?`,
      answer: $localize`Es posible que experimentes hipersensibilidad emocional. Permite lo que sientas sin juzgar, exprésalo con el cuerpo y observa. Por lo general son contenidos emocionales que salen y estaban reprimidos. Tómalo como una crisis curativa.`
    },
    {
      question: $localize`¿Qué pasa si “no siento nada” o “no sé que sentir”?`,
      answer: $localize`Recuerda que el efecto puede ser muy sutil. Puede ser desde un pequeño cambio en la toma de decisiones, ligeramente más enfocado, relajado o con más claridad, entre otros. Te compartimos esta frase: “El mejor día con microdosis es cuando ni te acuerdas que la tomaste pero te sentiste genial”.`
    },
    {
      question: $localize`¿Seré lo suficientemente funcional como para conducir o ir a trabajar mientras estoy en tratamiento?`,
      answer: $localize`¡Sí! En algunos casos, puede tomar uno o dos días acostumbrarse al medicamento, pero debe ser completamente funcional.`
    },
    {
      question: $localize`¿Cómo sé si tomé más dosis de la que debía?`,
      answer: $localize`En este caso te va a costar trabajo realizar tus actividades cotidianas, por ejemplo, manejar. Contacta a tu asesor para ver si es necesario ajustar tu fórmula.`
    },
    {
      question: $localize`Acciones y sustancias que debo evitar durante el tratamiento`,
      answer: $localize`Recomendamos limitar el consumo de alcohol, un máximo de 2 o 3 copas y de forma esporádica para obtener el máximo beneficio.<br />' +
        'Para tener un mejor beneficio, se recomienda evitar el consumo de cannabis, a menos de presentar adicción a esta sustancia y en cuyo caso de sigue un protocolo de adicciones paulatino. El motivo de esto es porque el hongo ayuda a reestructurar y dar claridad, mientras que el cannabis genera el efecto contrario, disminuye la plasticidad neuronal y tiene un efecto disociativo y redundante. <br />' +
        'No debe combinarse con otro tipo de drogas.`
    },
    {
      question: $localize`¿Puedo tomarme otra cápsula si siento ansiedad, estrés o depresión incluso después de haberme tomado la cantidad que indica mi protocolo?`,
      answer: $localize`Sí, si ya tomaste una dosis y todavía sientes mucha ansiedad, estrés o depresión puedes intentar tomar 1 ó 2 más. Si la molestia persiste, consulta con tu asesor.`
    },
    {
      question: $localize`¿Qué pasa si estoy embarazada o en lactancia?`,
      answer: $localize`No se han realizado estudios sobre la microdosis durante el embarazo o durante la lactancia, por lo que no podemos recomendarlo.`
    },
    {
      question: $localize`¿Qué significa si tengo sueño?`,
      answer: $localize`Las setas se adaptan a las necesidades específicas de tu cuerpo. Si tiene sueño con los hongos, le están pidiendo que descanse, ya que lo más probable es que se haya esforzado demasiado. A medida que nos reconectamos con nuestro cuerpo, nos damos cuenta de lo que está comunicando. Escúchalo.`
    },
    {
      question: $localize`¿Qué significa si tengo dolor de cabeza, me siento mareado o siento presión en la cabeza?`,
      answer: $localize`Puedes tomar un Advil o aspirina. Esta molestia se debe a un aumento de actividad cerebral y energía en el cerebro. Tu cuerpo puede tardar unos días en adaptarse a este nuevo ‘voltaje’, usualmente pasa después de 3 días. <br /> ' +
        'Este es el resultado del crecimiento de nuevas vías neuronales. Su cerebro se está reconectando y, a veces, esto puede causar algunos efectos secundarios. Esta reacción a veces puede ocurrir en personas con altos niveles de estrés, emociones reprimidas a largo plazo o desequilibrio intestinal.`
    },
    {
      question: $localize`¿Qué debo hacer si tengo dolor de cabeza por mi microdosis?`,
      answer: $localize`Esta es una respuesta natural y común a su adaptación al medicamento. Te recomendamos tomar una aspirina y mucha agua. Tu cuerpo puede tomar unos días en adaptarse a este aumento de actividad cerebral, usualmente pasa después de 3 días ¡Te estás adaptando!`
    },
    {
      question: $localize`¿Qué hago si tengo molestias digestivas (náusea, dificultad para digerirlo, inflamación)?`,
      answer: $localize`Cada cuerpo reacciona diferente y es normal encontrar este tipo de efectos secundarios. Te recomendamos acompañar la toma de tu cápsula con un plátano u otra fruta de tu preferencia.`
    },
    {
      question: $localize`¿Por qué me puedo sentir muy irritable mientras tomo el tratamiento?`,
      answer: $localize`Observa que el hongo está amplificando algo que te molesta y tal vez no te dabas cuenta.  Preguntar para saber detalles.`
    },
    {
      question: $localize`¿Qué hago si me siento irritable para convivir en grupos o en familia?`,
      answer: $localize`Es posible que te sientas hipersensible sin que necesariamente sea un tema a trabajar. Si notas que te molesta el ruido, la gente, etc, puedes descansar unos días sin tomar el tratamiento.`
    }
  ];

  constructor() { }

}
